<script>
    import { afterUpdate } from 'svelte';

    export let length = 0;
    export let active = 0;

    let iterable = [];

    afterUpdate(() => {
        iterable = [];

        for (let i = 1; i <= length; i++) {
            iterable = [...iterable, i]
        }
    })

</script>

<div class="dg-progress-bar">
    {#each iterable as step}
        <div class="dg-progress-bar__step" class:completed={step < active} class:active={step === active}>
            <div>{step}.</div>
        </div>
    {/each}
</div>

<style lang="scss">
    .dg-progress-bar {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 20px 0 !important;

        &__step {
            width: 25%;
            text-align: center;
            position: relative;

            &.completed {
                > div {
                    color: #fff;
                    border: 5px solid #0D78B7;
                    background-color: #0D78B7
                }

                &::after {
                    background-color: #0D78B7 !important;
                }
            }

            &.active {
                > div {
                    color: #0D78B7;
                    border: 5px solid #0D78B7;
                }
            }

            &:not(:last-child)::after {
                content: '';
                height: 5px;
                width: 100%;
                background-color: #DADADA;
                position: absolute;
                top: 43.7%;
                display: block;
                z-index: 1;
                right: -50%;
            }


            > div {
                width: 50px;
                height: 50px;
                margin: 0 auto;
                border-radius: 100%;
                color: #DADADA;
                border: 5px solid #DADADA;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 30px;
                font-weight: bold;
                z-index: 2;
                background: #fff;
                position: relative;
            }
        }
    }
</style>